import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 3C1 1.89543 1.89543 1 3 1H15C16.1046 1 17 1.89543 17 3V15C17 16.1046 16.1046 17 15 17H3C1.89543 17 1 16.1046 1 15V3Z"
      fill="#FFB743"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5557 11.6666V7.22211H5.44455V11.6666H12.5557ZM5.44455 5.44434H12.5557C12.7914 5.44434 13.0175 5.53799 13.1842 5.70469C13.3509 5.87138 13.4446 6.09748 13.4446 6.33322V11.6666C13.4446 11.9023 13.3509 12.1284 13.1842 12.2951C13.0175 12.4618 12.7914 12.5554 12.5557 12.5554H5.44455C5.20881 12.5554 4.98271 12.4618 4.81601 12.2951C4.64931 12.1284 4.55566 11.9023 4.55566 11.6666V6.33322C4.55566 6.09748 4.64931 5.87138 4.81601 5.70469C4.98271 5.53799 5.20881 5.44434 5.44455 5.44434Z"
      fill="white"
    />
    <circle
      cx={13.9998}
      cy={14}
      r={5}
      fill="#37363F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5472 14.1444V14.051C16.5471 14.0073 16.5357 13.9643 16.514 13.9263C16.4924 13.8883 16.4613 13.8565 16.4237 13.8341L13.4903 12.1187C13.2567 11.9819 13.1632 11.9819 13.0831 12.0286L12.9997 12.0753C12.9622 12.0978 12.9311 12.1295 12.9094 12.1675C12.8878 12.2055 12.8764 12.2485 12.8762 12.2922V15.9032C12.8775 15.9458 12.8895 15.9874 12.911 16.0241C12.9326 16.0609 12.9631 16.0916 12.9997 16.1134L13.0831 16.1601C13.1632 16.2069 13.2567 16.2069 13.4369 16.1001L16.4237 14.3614C16.4613 14.3389 16.4924 14.3071 16.514 14.2691C16.5357 14.2311 16.5471 14.1882 16.5472 14.1444Z"
      fill="white"
    />
  </svg>
);
const SvgDemoPresentTab = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgDemoPresentTab;
